import { render, staticRenderFns } from "./ClientsOverview.vue?vue&type=template&id=7294a4a2&scoped=true"
import script from "./ClientsOverview.vue?vue&type=script&lang=js"
export * from "./ClientsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294a4a2",
  null
  
)

export default component.exports